import { defineCustomElement } from '@tyler-components-web/core';
import { StepperComponent } from './stepper';
export * from './stepper';
export * from './stepper-adapter';
export * from './stepper-constants';
export * from './stepper-foundation';
export function defineStepperComponent() {
    defineCustomElement(StepperComponent);
}
